<div class="control-display">
  <ion-chip
    outline
    *ngFor="let eq of equipment"
    (click)="changeEquipment(eq)"
    [ngClass]="{'active-chip': isInEquipmentList(eq.id)}"
    >
    <ion-icon
      *ngIf="eq.iconName && eq.iconName != 'null'"
      [src]="'../../assets/icons/equipment/' + eq.iconName + '.svg'"
    ></ion-icon>
    <ion-label>{{ eq.name }}</ion-label>
  </ion-chip>
</div>
